
import AccessControlContainers from '../components/AccessControl';

export default AccessControlContainers;